import { render, staticRenderFns } from "./LoginModel.vue?vue&type=template&id=38a8ad7f&scoped=true"
import script from "./LoginModel.vue?vue&type=script&lang=js"
export * from "./LoginModel.vue?vue&type=script&lang=js"
import style0 from "./LoginModel.vue?vue&type=style&index=0&id=38a8ad7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8ad7f",
  null
  
)

export default component.exports